export enum TimeInterval {
  LAST_HOUR = 'LAST_HOUR',
  CURRENT_DAY = 'CURRENT_DAY',
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  CUSTOM = 'CUSTOM',
  NONE = 'NONE'
}
